import Vue from 'vue'
import {getFullName} from '@/helpers/utils'

Vue.filter('fullName', function(value) {
  return getFullName(value)
})
